import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_7: FaireProductEntity = {
  token: "atc_baggu_7",
  type: "product",
  name: "Standard Baggu Set of 3",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d8722cafb61a25e374d5c735db6d7bc56c55faad9da17e31142c4e761ad8c617.jpeg",
  priceDollars: 16,
  msrpDollars: 36,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
